import React from 'react'
import { invoiceStatus } from '@linqpal/models/src/dictionaries'
import { InvoiceListItem } from '../../../ui/atoms/InvoiceListItem'
import { dispatcher, pathFactory, paths } from '../../links'
import { getDisplayAmount } from '../../../utils/helpers/getDisplayAmount'

interface Props {
  invoices: any
  navigation: any
  route: any
  setModal?: (a) => void
}

export const InvoicesListDisplay = ({
  invoices,
  navigation,
  route,
  setModal,
}: Props) => {
  const canViewInvoiceDetails = [
    invoiceStatus.pastDue,
    invoiceStatus.due,
    invoiceStatus.placed,
    invoiceStatus.paymentFailed,
    invoiceStatus.applicationCancelled,
    invoiceStatus.applicationRejected,
    invoiceStatus.pendingDisbursement,
    invoiceStatus.applicationProcessing,
  ]
  const paidStatuses = [invoiceStatus.paid, invoiceStatus.collected]
  const InvoiceItemOnpress = (invoice) => {
    setModal && setModal(false)
    if (paidStatuses.includes(invoice.status)) {
      const action = dispatcher(pathFactory('Console.InvoicesToPay.Receipt'), {
        id: invoice._id,
      })
      navigation.replace(action.name, action.params)
    } else if (
      canViewInvoiceDetails.includes(invoice.status) &&
      !invoice.supplierInvitationDetails?.paymentMethodId // To check if payment was initiated for an uploaded invoice
    ) {
      if (route.name === 'list') {
        navigation.navigate(paths.Console.InvoicesToPay.Invoice, {
          id: invoice._id,
        })
      } else {
        navigation.navigate(paths.Console.InvoicesToPay._self, {
          screen: paths.Console.InvoicesToPay.Details,
          params: { id: invoice._id },
        })
      }
    }
  }
  return invoices.map((invoice) => (
    <InvoiceListItem
      key={invoice._id}
      onPress={() => InvoiceItemOnpress(invoice)}
      title={
        invoice.supplierInvitationDetails
          ? invoice.supplierInvitationDetails?.name
          : invoice.company?.name
      }
      subtitle={`Due on ${new Date(invoice.invoice_due_date)
        .toDateString()
        .slice(4, 10)}`}
      status={invoice.status}
      type={invoice.type}
      amount={getDisplayAmount(invoice.total_amount)}
      style={{ marginBottom: 10 }}
    />
  ))
}
